export const CREATE = "CREATE";
export const SUBMIT = "SUBMIT";
export const CREATE_EMPLOYEE_SUCCESS = "CREATE_EMPLOYEE_SUCCESS";
export const CREATE_EMPLOYEE_FAILURE = "CREATE_EMPLOYEE_FAILURE";
export const SUBMIT_RESPONSE_SUCCESS = "SUBMIT_RESPONSE_SUCCESS";
export const SUBMIT_RESPONSE_FAILURE = "SUBMIT_RESPONSE_FAILURE";



// WEBPACK FOOTER //
// ./src/constants/ActionConstants.js